import { render, staticRenderFns } from "./HumanFront.vue?vue&type=template&id=63eb40fa&"
import script from "./HumanFront.vue?vue&type=script&lang=js&"
export * from "./HumanFront.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports